import { useCallback, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

const API_URL = import.meta.env.VITE_API_URL;
const PREF_KEY = 'reportLanguage';

// Resolve a userId for preferences (reuse same pattern as other preference consumers)
function getUserId() {
  if (!localStorage.getItem('focusone_uid')) {
    localStorage.setItem('focusone_uid', 'u_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9));
  }
  return localStorage.getItem('focusone_uid');
}

export function useReportLanguage() {
  const [lang, setLang] = useState('en');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const uid = getUserId();
    fetch(`${API_URL}/api/preferences/${encodeURIComponent(uid)}/${PREF_KEY}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d && d.preference_value && (d.preference_value === 'en' || d.preference_value === 'nl')) {
          setLang(d.preference_value);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const setAndSave = useCallback((newLang) => {
    setLang(newLang);
    const uid = getUserId();
    fetch(`${API_URL}/api/preferences`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userEmail: uid, key: PREF_KEY, value: newLang }),
    }).catch(() => {});
  }, []);

  return { lang, setLang: setAndSave, loaded };
}

export default function ReportLanguageToggle({ value, onChange, compact }) {
  return (
    <div style={{ display: 'inline-flex', borderRadius: 6, overflow: 'hidden', border: '1px solid #dee2e6', fontSize: compact ? 11 : 12 }}>
      <button
        type="button"
        onClick={() => onChange('en')}
        style={{
          padding: compact ? '3px 8px' : '4px 10px',
          background: value === 'en' ? 'var(--teal)' : 'white',
          color: value === 'en' ? 'white' : 'var(--navy)',
          border: 'none', cursor: 'pointer', fontWeight: 600,
        }}
      >EN</button>
      <button
        type="button"
        onClick={() => onChange('nl')}
        style={{
          padding: compact ? '3px 8px' : '4px 10px',
          background: value === 'nl' ? 'var(--teal)' : 'white',
          color: value === 'nl' ? 'white' : 'var(--navy)',
          border: 'none', cursor: 'pointer', fontWeight: 600,
          borderLeft: '1px solid #dee2e6',
        }}
      >NL</button>
    </div>
  );
}
